<script setup lang="ts">
import { computed } from "vue";

import FocusStageTree from "./FocusStageTree.vue";

/**
 * The mint gradient tile the stage tree sits in (addendum §5).
 *
 * The tree is rooted on the tile's **bottom edge** — `align-items: flex-end`
 * is the whole point. A centred tree floats and undoes the ground line.
 */

const props = withDefaults(
  defineProps<{
    stage: number;
    /** 64px tile on Today's Focus card; 96px hero in the focus panel. */
    size?: "card" | "hero";
    sway?: boolean;
  }>(),
  { size: "card", sway: true },
);

const TILE_PX = { card: 64, hero: 96 } as const;

const tilePx = computed(() => TILE_PX[props.size]);
const treeSize = computed(() => (props.size === "hero" ? "hero" : "card"));
</script>

<template>
  <div
    class="stage-tile"
    :style="{ width: `${tilePx}px`, height: `${tilePx}px` }"
  >
    <FocusStageTree :stage="stage" :size="treeSize" :sway="sway" />
  </div>
</template>

<style scoped>
.stage-tile {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  border-radius: 15px;
  background: linear-gradient(180deg, var(--rl-mint-100), var(--rl-bg-subtle));
}
</style>
